module.exports = __webpack_public_path__ + "static/media/badges.873b0945.png";